// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW6_buttonsContainer__ipmQ2","editableSpanContainer":"HW6_editableSpanContainer__Xwdsa"};